import { render, staticRenderFns } from "./TooltipGemeinden.vue?vue&type=template&id=0d86c64d&"
import script from "./TooltipGemeinden.vue?vue&type=script&lang=js&"
export * from "./TooltipGemeinden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports